import React from 'react';
import { KonteringUtils } from './KonteringManagerUtils';
import { IUIUrval } from '../../../../../Types/UrvalTypes';
import { KonteringManagerQuery_db_SYSBokfar_All } from './Query/_QueryTypes/KonteringManagerQuery';

export interface IKonteringManagerContext {
  attestKodbehorigheterUrval: IAttestKodbehorighetUrval[] | null;
  bokforingsAr: KonteringManagerQuery_db_SYSBokfar_All[];
  konteringUtils: KonteringUtils;
  konteringValidationQueryLoading: boolean;
}

export interface IKodbehorighetUrval {
  urval: IUIUrval;
  kodplanID: string | undefined;
}
export interface IAttestKodbehorighetUrval extends IKodbehorighetUrval {
  omradesId: string | null | undefined;
  attestRattID: string | null | undefined;
  attestTyp: string | undefined;
  maxbelopp: number | null | undefined;
  hasKontrollAttestant: boolean | null | undefined;
  kontrollbelopp: number | null | undefined;
}

export interface IBokforderKodbehorigheter extends IKodbehorighetUrval {
  FOR_BOKFORDER: boolean | null | undefined;
  FOR_UTANORDNING: boolean | null | undefined;
  UTANORDNING_KONTROLL: boolean | null | undefined;
  UTANORDNING_KA_MAXBELOPP: number | null | undefined;
  UTANORDNING_KONTROLLBELOPP: number | null | undefined;
}

const defaultValues: IKonteringManagerContext = {
  attestKodbehorigheterUrval: [],
  bokforingsAr: [],
  konteringUtils: new KonteringUtils([], () => {}, '', [], []),
  konteringValidationQueryLoading: false,
};

export const KonteringContext =
  React.createContext<IKonteringManagerContext>(defaultValues);

export const KonteringContextProvider = KonteringContext.Provider;
export default KonteringContext;
